<template>
  <section class="hub-library" id="resources-library">
    <h2 class="hub-library__title" v-html="getTitleBlock(page, 'library', 'title')"></h2>
    <p class="hub-library__description" v-html="getTitleBlock(page, 'library', 'description')"></p>

    <div class="hub-library__grid">
      <LibraryCard
        v-for="document in documents"
        :key="document.id"
        :document="document"
        :selected="isDocumentSelected(document.slug)"
        @toggle="toggleDocument"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LibraryCard from './library-card';
import { textBlock } from '@/entities/text-block';
import { RESOURCE_DOCUMENTS, RESOURCES_HUB_TEXT_PAGE, RESOURCES_HUB_VISIBLE_CARDS } from '@/features/agent-resources/config';

export default {
  mixins: [ textBlock ],
  components: { LibraryCard },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
      documents: RESOURCE_DOCUMENTS.slice(0, RESOURCES_HUB_VISIBLE_CARDS),
    };
  },
  computed: {
    ...mapGetters('agentResourcesModule', ['isDocumentSelected']),
  },
  methods: {
    ...mapActions('agentResourcesModule', ['toggleDocument']),
  },
};
</script>

<style lang="scss" scoped>
.hub-library {
  max-width: 1328px;
  margin: 0 auto;
  padding: 48px 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 800px) {
    padding: 24px 16px 0;
  }

  &__title {
    margin: 0 0 20px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.15;
    text-align: center;
  }

  &__description {
    margin: 0 0 48px;
    max-width: 760px;
    font-size: 17px;
    line-height: 26px;
    color: #4E5358;
    text-align: center;
  }

  &__grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 24px;
  }
}
</style>
